import {SpellTime} from '../../generated/types';
import {humanEnumeration} from '../utils';
import {castingTimeUnitToString} from './casting-time-unit-to-string';

/** Время сотворения: «Действие или Ритуал», с условием ответного действия */
export function toSpellTime(times: SpellTime[], ritual?: boolean | null) {
	const result = times.map((time) => {
		let text = castingTimeUnitToString(time.number, time.unit);
		if (time.condition) text += `, ${time.condition}`;
		return text;
	});

	if (ritual) result.push('Ритуал');

	return humanEnumeration(result, 'или');
}
